import { LitElement, html } from "lit";
import { template } from "./template";
import { customElement, property } from "lit/decorators.js";

@customElement("quick-action-item")
export class QuickActionItem extends LitElement {
  constructor(icon: string, label: string, callbackFn: () => void) {
    super();
    this.icon = icon;
    this.label = label;
    this.callbackFn = callbackFn;
  }

  render() {
    return html`${template(this)}`;
  }

  @property({ type: String }) icon = "";
  @property({ type: String }) label = "";
  @property({ attribute: false }) callbackFn = () => {};
}
